
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35404',
  depVersions: {
  "documents-public-ui": "static-1.35404",
  "atom": "static-1.5474",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2877",
  "client-types": "static-1.504",
  "cssUtils": "static-1.1015",
  "customer-data-filters-ui": "static-1.41161",
  "customer-data-objects": "static-1.8086",
  "customer-data-property-utils": "static-1.8458",
  "documents-lib": "static-1.35409",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.377",
  "FormsCommonComponents": "static-1.86715",
  "FormUrlGenerator": "static-2.5107",
  "foundations-theming-specialty": "static-1.2590",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5984",
  "hs-test-utils": "static-1.8431",
  "hub-http": "static-1.6605",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12193",
  "HubStyleTokens": "static-2.11886",
  "I18n": "static-7.1690",
  "icons": "static-2.698",
  "jasmine-immutable": "static-1.3371",
  "jasmine-runner": "static-1.6842",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7545",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3283",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5776",
  "quartz": "static-1.7565",
  "react": "static-7.202",
  "react-dlb": "static-1.92",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17125",
  "react-select-plus": "static-1.116",
  "react-utils": "static-2.5612",
  "react-virtualized": "static-2.110",
  "reference-resolvers": "static-1.8576",
  "reference-resolvers-lite": "static-1.8497",
  "reporting-data": "static-1.69096",
  "reporting-reports": "static-1.68772",
  "reporting-snowflake": "static-1.57712",
  "reporting-testing-lib": "static-1.11029",
  "reporting-visualizations": "static-1.61170",
  "reselect": "static-3.15",
  "sales-content-partitioning": "static-1.9343",
  "sanitize": "static-1.4866",
  "sanitize-text": "static-1.8552",
  "SharedI18nStrings": "static-1.186",
  "SharedLegalStrings": "static-1.2124",
  "signup-constants": "static-1.19779",
  "signup-ui-url-generator": "static-2.8453",
  "StyleGuideUI": "static-3.511",
  "superstore": "static-1.5154",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5141",
  "ui-addon-form-validation": "static-1.11334",
  "ui-asset-management-lib": "static-1.11496",
  "ui-images": "static-2.1268",
  "UIComponents": "static-3.8832",
  "usage-tracker": "static-1.7707",
  "usage-tracker-container": "static-1.7697",
  "usage-tracker-core": "static-1.7557",
  "viral-links-lib": "static-1.7470",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10041",
  "foundations-components": "static-1.8627",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1343",
  "quartz-core": "static-1.6784",
  "quick-fetch": "static-1.4182",
  "raven": "static-3.5925",
  "redux": "static-4.81",
  "redux-thunk": "static-2.83",
  "rpc-client-utils": "static-1.5061",
  "ui-addon-i18n": "static-1.11543",
  "ui-addon-upgrades": "static-9.18488",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3842",
  "quartz-webpack": "static-1.3789",
  "foundations-assets": "static-1.5283",
  "foundations-theming": "static-1.4874",
  "hub-http-janus": "static-1.895",
  "hub-http-shared-msw-handlers": "static-1.10764",
  "hubspotter-http": "static-1.4917",
  "sassPrefix": "static-1.283",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.43938",
  "customer-data-filters-ui-msw-helpers": "static-1.23596",
  "customer-data-objects-ui-components": "static-1.13424",
  "customer-data-reference-ui-components": "static-1.13563",
  "customer-data-ui-utilities": "static-1.10227",
  "events-data-lib": "static-1.642",
  "framework-builder-read-service-client": "static-1.4279",
  "hs-resources": "static-1.588",
  "immer": "static-1.104",
  "inbound-db-meta-service-client": "static-1.3731",
  "inbound-db-properties-service-client": "static-1.4101",
  "multi-account-reference-resolvers": "static-1.1398",
  "onboarding-scopes": "static-1.6847",
  "onboarding-tours": "static-1.17269",
  "pulse": "static-1.1030",
  "reporting-datasets-permissions-lib": "static-1.14622",
  "segments-client-types": "static-1.11885",
  "stylex": "static-1.45",
  "trellis-assets": "static-1.2886",
  "trellis-components": "static-1.2905",
  "trellis-theming": "static-1.1371",
  "ui-addon-teams": "static-1.21968",
  "quartz-auth": "static-1.1240",
  "ui-business-units-lib": "static-1.9490",
  "usage-tracker-session-replay": "static-1.5393",
  "ai-components-ui-library": "static-1.9887",
  "ContentUtils": "static-1.69305",
  "customer-data-properties": "static-1.52831",
  "forms-ai-lib": "static-1.4876",
  "forms-utils-lib": "static-1.13215",
  "foundations-components-test-utils": "static-1.6110",
  "react-dnd-compat": "static-1.5008",
  "react-tinymce": "static-1.56136",
  "tinymce-config": "static-2.55262",
  "ui-gdpr-components": "static-1.10648",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3859",
  "HeadJS": "static-2.810",
  "framer-motion": "static-1.82",
  "hs-test-utils-bend-plugin": "static-1.3542",
  "msw": "static-1.39",
  "msw-config": "static-1.15",
  "testing-library": "static-1.162",
  "hs-locale-management": "static-1.351",
  "ui-fonts": "static-1.1148",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4704",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1230",
  "web-vitals": "static-1.18",
  "batch-promise": "static-1.1940",
  "external-options-client-types": "static-1.4399",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7290",
  "quartz-i18n": "static-1.1240",
  "frontend-preferences-client": "static-1.8315",
  "graphql": "static-1.92",
  "persist-promise": "static-1.4097",
  "reporting-client-types": "static-1.2765",
  "apollo-stack-hubspot": "static-3.97",
  "growth-payments-core": "static-1.26353",
  "hubspot-apollo-client": "static-1.5268",
  "foundations-components-legacy": "static-1.1652",
  "quartz-routing": "static-1.995",
  "hs-story-utils": "static-1.9819",
  "react-flip-move": "static-1.81",
  "nested-table": "static-1.630",
  "seat-types-lib": "static-1.897",
  "timezone-utils": "static-2.5626",
  "react-create-root-preference": "static-1.87",
  "bend-plugin-foundations-components": "static-1.4896",
  "floating-ui": "static-1.66",
  "react-aria": "static-1.75",
  "tanstack-table": "static-1.64",
  "opentelemetry-fe-types": "static-1.179",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.591",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.554",
  "quartz-test": "static-1.1240",
  "quartz-tracking": "static-1.944",
  "bend-plugin-chirp-manifest": "static-1.471",
  "chirp-fetch": "static-1.2295",
  "merchandise-lib": "static-1.282",
  "purchase-motions-components": "static-1.6536",
  "ts-schema": "static-1.4351",
  "bender-build-tools": "static-1.3472",
  "bend-plugin-foundations-theming": "static-1.3357",
  "restore-request-side-panel-lib": "static-1.1864",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5016",
  "conditional-properties-service-client": "static-1.4073",
  "crm-pipelines-api-client-types": "static-1.4404",
  "event-emitter": "static-1.1354",
  "fdsr-migration-layer": "static-1.409",
  "multi-currency-client-types": "static-1.3968",
  "getting-started-shared-tasks": "static-1.19417",
  "growth-data-modal": "static-1.6016",
  "growth-onboarding-confetti": "static-1.3458",
  "growth-onboarding-next-action-utils": "static-1.2847",
  "navigation-components": "static-1.19008",
  "onboarding-tours-client": "static-1.5484",
  "onboarding-tours-utils": "static-1.1336",
  "ui-shepherd-react": "static-3.10666",
  "ui-shepherd-tracker": "static-1.8047",
  "ui-universal-auth": "static-1.9584",
  "user-context": "static-1.5473",
  "bend-plugin-pulse": "static-1.533",
  "fast-json-patch": "static-1.73",
  "crm-index-associations-lib": "static-1.6840",
  "stylex-utils": "static-1.156",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "tanstack-virtual": "static-1.41",
  "hubspotter-http-shared-msw-handlers": "static-1.10762",
  "magpie-lib": "static-1.5832",
  "navigation-messaging": "static-1.8335",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23394",
  "copilot-toolkit": "static-1.12002",
  "cms-field-types": "static-1.5206",
  "content-icons-ui": "static-1.2415",
  "integrations-lib": "static-1.17248",
  "calling-global-api": "static-1.65891",
  "calling-internal-common": "static-1.31716",
  "calling-lifecycle-internal": "static-1.67273",
  "calling-lifecycle-messages": "static-1.59566",
  "commerce-products-lib": "static-1.10719",
  "crm-index-visualization-core": "static-1.4651",
  "crm-links": "static-1.6695",
  "customer-data-properties-shared-msw-handlers": "static-1.10091",
  "file-manager-components": "static-1.24685",
  "formula-editor": "static-1.14901",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4482",
  "meetings-icalendar-utils-lib": "static-1.1031",
  "object-builder-ui-client": "static-1.49867",
  "pipeline-validation-client-types": "static-1.4241",
  "property-value-citations": "static-1.3445",
  "smart-data-capture-core": "static-1.298",
  "smart-property-lib": "static-1.8481",
  "tiered-pricing": "static-1.2101",
  "topics-actions-lib": "static-1.568",
  "trial-components-library": "static-1.14251",
  "ui-addon-iframeable": "static-1.9474",
  "zustand": "static-1.86",
  "final-form": "static-1.81",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.81",
  "rich-text-lib": "static-1.20437",
  "tinymce-themes": "static-1.57232",
  "data-token-picker": "static-1.17012",
  "hub-http-contrib": "static-1.3421",
  "interframe": "static-3.5136",
  "tinymce-data": "static-1.41347",
  "tinymce-plugins": "static-1.58376",
  "ui-addon-sales-email": "static-1.5597",
  "framework-data-schema-quick-fetch": "static-1.7195",
  "ui-addon-opt": "static-4.8763",
  "hubspot-apollo-cache": "static-1.727",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.541",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.96",
  "purchase-motions-api": "static-1.6539",
  "onboarding-data-sync-lib": "static-1.2701",
  "growth-onboarding-next-action-components": "static-1.2875",
  "user-context-client": "static-1.4904",
  "idb-keyval": "static-1.54",
  "magpie-types": "static-1.5292",
  "nest": "static-1.630",
  "reactive-lib": "static-1.1115",
  "simple-logging-lib": "static-1.3447",
  "unified-auth-core-lib": "static-1.1380",
  "getting-started-shared-tasks-store": "static-1.18535",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1963",
  "integrations-error-boundary-lib": "static-1.14663",
  "integrations-tracking-lib": "static-1.6005",
  "native-integrations-shared-strings": "static-1.8158",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10765",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1098",
  "calling-error-reporting": "static-1.31723",
  "shared-worker-versioning": "static-1.11436",
  "calling-usage-tracker": "static-1.6930",
  "voice-sms-access-library": "static-1.2267",
  "customer-data-tracking": "static-1.7266",
  "commerce-permissions": "static-1.1171",
  "products-iframe-lib": "static-1.8740",
  "products-ui-components-shared-msw-handlers": "static-1.11146",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10847",
  "sales-views-client-types": "static-1.4651",
  "location-customization-utils-lib": "static-1.10274",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4538",
  "poll-commands": "static-1.3867",
  "video-components-external": "static-1.12303",
  "video-data-lib": "static-1.35961",
  "bark-lib": "static-1.16924",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6283",
  "react-codemirror": "static-1.11036",
  "data-agent-kit": "static-1.775",
  "feedback-loader": "static-1.29939",
  "fsm": "static-1.4148",
  "policy-lib": "static-1.7202",
  "react-colorpicker": "static-2.10607",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10910",
  "embedded-academy-lib": "static-1.15765",
  "hubs-service-types": "static-1.1656",
  "nudge-client-utils": "static-1.3280",
  "salesImages": "static-1.655",
  "FileManagerLib": "static-1.40325",
  "NamespacedHubStyle": "static-2.9316",
  "FileManagerCore": "static-1.40184",
  "content-assistance-lib": "static-1.8316",
  "layout-dnd-components": "static-1.13100",
  "layout-dnd-utils": "static-1.12075",
  "ui-addon-emoji-picker": "static-1.10264",
  "ui-brand-identity-lib": "static-1.16747",
  "InboxConnectUtils": "static-4.15709",
  "meetings-connect-utils-lib": "static-1.8009",
  "breeze-engine-chat-components": "static-1.941",
  "breeze-engine-core": "static-1.1241",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "universal-page-editor-lib": "static-1.3405",
  "adobe-sign-auth-lib": "static-1.627",
  "ads-unified-auth-lib": "static-1.1686",
  "custom-vendor-connection-lib": "static-1.148",
  "google-sheets-integration-lib": "static-1.1190",
  "microsoft-drive-auth-lib": "static-1.347",
  "surveymonkey-integration-lib": "static-1.699",
  "slack-ui-library": "static-1.10793",
  "calling-orchestration-schema": "static-1.37044",
  "crm-record-cards-service-types": "static-1.3827",
  "content-media-composition-data-lib": "static-1.13435",
  "content-media-compositions": "static-2.17442",
  "media-bridge-lib": "static-1.19530",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16521",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4901",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15225",
  "nudge-custom-function-registry": "static-1.3037",
  "nudge-renderer-utils": "static-1.3356",
  "whisper-core-api": "static-1.7492",
  "audio-components": "static-1.6464",
  "FileManagerImages": "static-1.37836",
  "video-components": "static-1.14305",
  "breeze-artifacts-sdk": "static-1.620",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4911",
  "video-embed": "static-1.36795",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29465",
  "ContentData": "static-1.69380",
  "layout-data-lib": "static-1.10400",
  "academy-service-client": "static-1.4087",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4789",
  "trellis-ecosystem": "static-1.7742",
  "ui-addon-react-router-dom": "static-1.9924",
  "wootric-nps": "static-1.7253",
  "social-insights-client-types": "static-1.22791",
  "outpost": "static-1.4531",
  "growth-onboarding-feedback-components": "static-1.6980",
  "advanced-menus-core": "static-1.15696",
  "advanced-menus-lib": "static-1.12510",
  "ExportDialog": "static-6.10772",
  "ui-memberships-settings-lib": "static-1.34999",
  "marketplace-ui-apps-core": "static-1.19447",
  "marketplace-ui-common": "static-1.20915",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15695",
  "simple-menus-lib": "static-1.17212",
  "settings-ui-lib": "static-1.12923",
  "developer-experience-shared-components": "static-1.10931",
  "immutable-less": "static-1.5046",
  "marketplace-ui-client-types": "static-1.18322",
  "ui-addon-integrations-directory-panel": "static-2.8386",
  "ui-extensibility-client-types": "static-1.4311",
  "ai-settings-ui-library": "static-1.8463",
  "nav-meta": "static-1.30645",
  "ui-product-approvals-common": "static-1.1355",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "simple-data-table": "static-1.3673"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35404",
  "atom": "/atom/static-1.5474",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2877",
  "client-types": "/client-types/static-1.504",
  "cssUtils": "/cssUtils/static-1.1015",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41161",
  "customer-data-objects": "/customer-data-objects/static-1.8086",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8458",
  "documents-lib": "/documents-lib/static-1.35409",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.377",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86715",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5107",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2590",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5984",
  "hs-test-utils": "/hs-test-utils/static-1.8431",
  "hub-http": "/hub-http/static-1.6605",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12193",
  "HubStyleTokens": "/HubStyleTokens/static-2.11886",
  "I18n": "/I18n/static-7.1690",
  "icons": "/icons/static-2.698",
  "jasmine-immutable": "/jasmine-immutable/static-1.3371",
  "jasmine-runner": "/jasmine-runner/static-1.6842",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7545",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3283",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5776",
  "quartz": "/quartz/static-1.7565",
  "react": "/react/static-7.202",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17125",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-utils": "/react-utils/static-2.5612",
  "react-virtualized": "/react-virtualized/static-2.110",
  "reference-resolvers": "/reference-resolvers/static-1.8576",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8497",
  "reporting-data": "/reporting-data/static-1.69096",
  "reporting-reports": "/reporting-reports/static-1.68772",
  "reporting-snowflake": "/reporting-snowflake/static-1.57712",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11029",
  "reporting-visualizations": "/reporting-visualizations/static-1.61170",
  "reselect": "/reselect/static-3.15",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9343",
  "sanitize": "/sanitize/static-1.4866",
  "sanitize-text": "/sanitize-text/static-1.8552",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2124",
  "signup-constants": "/signup-constants/static-1.19779",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8453",
  "StyleGuideUI": "/StyleGuideUI/static-3.511",
  "superstore": "/superstore/static-1.5154",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5141",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11334",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11496",
  "ui-images": "/ui-images/static-2.1268",
  "UIComponents": "/UIComponents/static-3.8832",
  "usage-tracker": "/usage-tracker/static-1.7707",
  "usage-tracker-container": "/usage-tracker-container/static-1.7697",
  "usage-tracker-core": "/usage-tracker-core/static-1.7557",
  "viral-links-lib": "/viral-links-lib/static-1.7470",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10041",
  "foundations-components": "/foundations-components/static-1.8627",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1343",
  "quartz-core": "/quartz-core/static-1.6784",
  "quick-fetch": "/quick-fetch/static-1.4182",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.83",
  "rpc-client-utils": "/rpc-client-utils/static-1.5061",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11543",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18488",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3842",
  "quartz-webpack": "/quartz-webpack/static-1.3789",
  "foundations-assets": "/foundations-assets/static-1.5283",
  "foundations-theming": "/foundations-theming/static-1.4874",
  "hub-http-janus": "/hub-http-janus/static-1.895",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10764",
  "hubspotter-http": "/hubspotter-http/static-1.4917",
  "sassPrefix": "/sassPrefix/static-1.283",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.43938",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23596",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13424",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13563",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10227",
  "events-data-lib": "/events-data-lib/static-1.642",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4279",
  "hs-resources": "/hs-resources/static-1.588",
  "immer": "/immer/static-1.104",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3731",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4101",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1398",
  "onboarding-scopes": "/onboarding-scopes/static-1.6847",
  "onboarding-tours": "/onboarding-tours/static-1.17269",
  "pulse": "/pulse/static-1.1030",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14622",
  "segments-client-types": "/segments-client-types/static-1.11885",
  "stylex": "/stylex/static-1.45",
  "trellis-assets": "/trellis-assets/static-1.2886",
  "trellis-components": "/trellis-components/static-1.2905",
  "trellis-theming": "/trellis-theming/static-1.1371",
  "ui-addon-teams": "/ui-addon-teams/static-1.21968",
  "quartz-auth": "/quartz-auth/static-1.1240",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9490",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5393",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9887",
  "ContentUtils": "/ContentUtils/static-1.69305",
  "customer-data-properties": "/customer-data-properties/static-1.52831",
  "forms-ai-lib": "/forms-ai-lib/static-1.4876",
  "forms-utils-lib": "/forms-utils-lib/static-1.13215",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6110",
  "react-dnd-compat": "/react-dnd-compat/static-1.5008",
  "react-tinymce": "/react-tinymce/static-1.56136",
  "tinymce-config": "/tinymce-config/static-2.55262",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10648",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3859",
  "HeadJS": "/HeadJS/static-2.810",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3542",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.15",
  "testing-library": "/testing-library/static-1.162",
  "hs-locale-management": "/hs-locale-management/static-1.351",
  "ui-fonts": "/ui-fonts/static-1.1148",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4704",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1230",
  "web-vitals": "/web-vitals/static-1.18",
  "batch-promise": "/batch-promise/static-1.1940",
  "external-options-client-types": "/external-options-client-types/static-1.4399",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7290",
  "quartz-i18n": "/quartz-i18n/static-1.1240",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8315",
  "graphql": "/graphql/static-1.92",
  "persist-promise": "/persist-promise/static-1.4097",
  "reporting-client-types": "/reporting-client-types/static-1.2765",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.97",
  "growth-payments-core": "/growth-payments-core/static-1.26353",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5268",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1652",
  "quartz-routing": "/quartz-routing/static-1.995",
  "hs-story-utils": "/hs-story-utils/static-1.9819",
  "react-flip-move": "/react-flip-move/static-1.81",
  "nested-table": "/nested-table/static-1.630",
  "seat-types-lib": "/seat-types-lib/static-1.897",
  "timezone-utils": "/timezone-utils/static-2.5626",
  "react-create-root-preference": "/react-create-root-preference/static-1.87",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4896",
  "floating-ui": "/floating-ui/static-1.66",
  "react-aria": "/react-aria/static-1.75",
  "tanstack-table": "/tanstack-table/static-1.64",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.179",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.591",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.554",
  "quartz-test": "/quartz-test/static-1.1240",
  "quartz-tracking": "/quartz-tracking/static-1.944",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.471",
  "chirp-fetch": "/chirp-fetch/static-1.2295",
  "merchandise-lib": "/merchandise-lib/static-1.282",
  "purchase-motions-components": "/purchase-motions-components/static-1.6536",
  "ts-schema": "/ts-schema/static-1.4351",
  "bender-build-tools": "/bender-build-tools/static-1.3472",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3357",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1864",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5016",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4073",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4404",
  "event-emitter": "/event-emitter/static-1.1354",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.409",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3968",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19417",
  "growth-data-modal": "/growth-data-modal/static-1.6016",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3458",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2847",
  "navigation-components": "/navigation-components/static-1.19008",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5484",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1336",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10666",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8047",
  "ui-universal-auth": "/ui-universal-auth/static-1.9584",
  "user-context": "/user-context/static-1.5473",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.533",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6840",
  "stylex-utils": "/stylex-utils/static-1.156",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10762",
  "magpie-lib": "/magpie-lib/static-1.5832",
  "navigation-messaging": "/navigation-messaging/static-1.8335",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23394",
  "copilot-toolkit": "/copilot-toolkit/static-1.12002",
  "cms-field-types": "/cms-field-types/static-1.5206",
  "content-icons-ui": "/content-icons-ui/static-1.2415",
  "integrations-lib": "/integrations-lib/static-1.17248",
  "calling-global-api": "/calling-global-api/static-1.65891",
  "calling-internal-common": "/calling-internal-common/static-1.31716",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67273",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59566",
  "commerce-products-lib": "/commerce-products-lib/static-1.10719",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4651",
  "crm-links": "/crm-links/static-1.6695",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10091",
  "file-manager-components": "/file-manager-components/static-1.24685",
  "formula-editor": "/formula-editor/static-1.14901",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4482",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1031",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49867",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4241",
  "property-value-citations": "/property-value-citations/static-1.3445",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.298",
  "smart-property-lib": "/smart-property-lib/static-1.8481",
  "tiered-pricing": "/tiered-pricing/static-1.2101",
  "topics-actions-lib": "/topics-actions-lib/static-1.568",
  "trial-components-library": "/trial-components-library/static-1.14251",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9474",
  "zustand": "/zustand/static-1.86",
  "final-form": "/final-form/static-1.81",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "rich-text-lib": "/rich-text-lib/static-1.20437",
  "tinymce-themes": "/tinymce-themes/static-1.57232",
  "data-token-picker": "/data-token-picker/static-1.17012",
  "hub-http-contrib": "/hub-http-contrib/static-1.3421",
  "interframe": "/interframe/static-3.5136",
  "tinymce-data": "/tinymce-data/static-1.41347",
  "tinymce-plugins": "/tinymce-plugins/static-1.58376",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5597",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7195",
  "ui-addon-opt": "/ui-addon-opt/static-4.8763",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.727",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.541",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.96",
  "purchase-motions-api": "/purchase-motions-api/static-1.6539",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2701",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2875",
  "user-context-client": "/user-context-client/static-1.4904",
  "idb-keyval": "/idb-keyval/static-1.54",
  "magpie-types": "/magpie-types/static-1.5292",
  "nest": "/nest/static-1.630",
  "reactive-lib": "/reactive-lib/static-1.1115",
  "simple-logging-lib": "/simple-logging-lib/static-1.3447",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1380",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18535",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1963",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14663",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6005",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8158",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10765",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1098",
  "calling-error-reporting": "/calling-error-reporting/static-1.31723",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11436",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6930",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2267",
  "customer-data-tracking": "/customer-data-tracking/static-1.7266",
  "commerce-permissions": "/commerce-permissions/static-1.1171",
  "products-iframe-lib": "/products-iframe-lib/static-1.8740",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11146",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10847",
  "sales-views-client-types": "/sales-views-client-types/static-1.4651",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10274",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4538",
  "poll-commands": "/poll-commands/static-1.3867",
  "video-components-external": "/video-components-external/static-1.12303",
  "video-data-lib": "/video-data-lib/static-1.35961",
  "bark-lib": "/bark-lib/static-1.16924",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6283",
  "react-codemirror": "/react-codemirror/static-1.11036",
  "data-agent-kit": "/data-agent-kit/static-1.775",
  "feedback-loader": "/feedback-loader/static-1.29939",
  "fsm": "/fsm/static-1.4148",
  "policy-lib": "/policy-lib/static-1.7202",
  "react-colorpicker": "/react-colorpicker/static-2.10607",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10910",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15765",
  "hubs-service-types": "/hubs-service-types/static-1.1656",
  "nudge-client-utils": "/nudge-client-utils/static-1.3280",
  "salesImages": "/salesImages/static-1.655",
  "FileManagerLib": "/FileManagerLib/static-1.40325",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9316",
  "FileManagerCore": "/FileManagerCore/static-1.40184",
  "content-assistance-lib": "/content-assistance-lib/static-1.8316",
  "layout-dnd-components": "/layout-dnd-components/static-1.13100",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12075",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10264",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16747",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15709",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8009",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.941",
  "breeze-engine-core": "/breeze-engine-core/static-1.1241",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3405",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.627",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1686",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.148",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1190",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.347",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.699",
  "slack-ui-library": "/slack-ui-library/static-1.10793",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37044",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3827",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13435",
  "content-media-compositions": "/content-media-compositions/static-2.17442",
  "media-bridge-lib": "/media-bridge-lib/static-1.19530",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16521",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4901",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15225",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3037",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3356",
  "whisper-core-api": "/whisper-core-api/static-1.7492",
  "audio-components": "/audio-components/static-1.6464",
  "FileManagerImages": "/FileManagerImages/static-1.37836",
  "video-components": "/video-components/static-1.14305",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.620",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4911",
  "video-embed": "/video-embed/static-1.36795",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29465",
  "ContentData": "/ContentData/static-1.69380",
  "layout-data-lib": "/layout-data-lib/static-1.10400",
  "academy-service-client": "/academy-service-client/static-1.4087",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4789",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7742",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9924",
  "wootric-nps": "/wootric-nps/static-1.7253",
  "social-insights-client-types": "/social-insights-client-types/static-1.22791",
  "outpost": "/outpost/static-1.4531",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6980",
  "advanced-menus-core": "/advanced-menus-core/static-1.15696",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12510",
  "ExportDialog": "/ExportDialog/static-6.10772",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34999",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19447",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20915",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15695",
  "simple-menus-lib": "/simple-menus-lib/static-1.17212",
  "settings-ui-lib": "/settings-ui-lib/static-1.12923",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10931",
  "immutable-less": "/immutable-less/static-1.5046",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18322",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8386",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4311",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8463",
  "nav-meta": "/nav-meta/static-1.30645",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1355",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "simple-data-table": "/simple-data-table/static-1.3673"
}
};
